(function importerModuleDefinition() {
    'use strict';

    angular.module('Importer', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'ui.select', 'ui.selectExtend', 'ngFileUpload'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function importerConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('importer-add', {
                    url: "/Importer/Add",
                    templateUrl: config.resourceUrl('/views/importer/add-file.html'),
                    controller: 'ImporterAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USER WRITE')
                });
            }
        ]);
})();